import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-error-unauthorized',
  imports: [CommonModule],
  templateUrl: './error-unauthorized.component.html',
  styleUrl: './error-unauthorized.component.css'
})
export class ErrorUnauthorizedComponent {

  contextStr: string | null = null;

  ngOnInit() {
    this.contextStr = sessionStorage.getItem("context") ?? null;
  }
}
